import React from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { Redirect } from 'react-router-dom';
import * as Sentry from '@sentry/browser';

import store from '../store/store';
import { pushModal } from '../store/actions/modal-actions';

const mapStateToProps = (
  { client }
) => ({
  client,
});

class ErrorBoundary extends React.Component {
  state = { hasError: false, eventId: null };

  componentDidCatch(error, info) {
    this.setState(
      () => ({ hasError: true }),
      () => {
        store.dispatch(
          pushModal({
            title: 'Error',
            message:
              'Sorry an error has occurred',
          }));
      }
    );

    Sentry.withScope(scope => {
      scope.setExtra('Account name', this.props.client.name);
      scope.setExtra('Account id', this.props.client.id);
      scope.setExtra('Account type', this.props.client.accountType);
      scope.setExtra('country', this.props.client.country);
      scope.setExtras(info);
      const eventId = Sentry.captureException(error);
      this.setState({eventId})
    });

  }
  render() {
    if (this.state.hasError) {
      Sentry.showReportDialog({ eventId: this.state.eventId })
      return <Redirect to="/" />;
    }
    return this.props.children;
  }
}

ErrorBoundary.propTypes = {
  children: PropTypes.node.isRequired,
};

export default connect(
  mapStateToProps,
)(ErrorBoundary);
